export default "__VITE_ASSET__D5zQg_9f__"